import React, { useState, useRef } from 'react'
import _ from 'lodash'

export default function PlayerRow(props) {
  const { game, pr } = props
  const [editCost, setEditCost] = useState(false)
  const costInputRef = useRef(null)
  const isGameFull = game.number_of_players >= game.max_number_of_players
  const paid_amount = parseFloat(pr.paid_amount)
  const cost_of_player = parseFloat(pr.cost_of_player)
  const isFullyPaid = paid_amount >= cost_of_player
  const authHold = pr.state == 'hold'

  const changeCost = () => {
    const cost = costInputRef.current.value
    if (cost < 0 || cost > 1000000) return

    if (pr.cost_of_player != cost) {
      setEditCost(false)
      props.onEditCost({id: pr.id, cost: cost})
    }
  }
  
  const paymentAction = () => {
    if (authHold) return <td className='col-xs-1 actions'>
      <button className='btn btn-success payment-type' type='button' disabled={true}>Hold</button>
    </td>

    if (isFullyPaid) return <td className='col-xs-1 actions'>
      <button className='btn btn-success payment-type' type='button' disabled={true}
        style={{'fontSize': pr.payment_type_label == 'Cash App' ? 'x-small' : 'unset'}}>
        {pr.payment_type_label}
      </button>
    </td>

    return <td className='col-xs-1 actions'>
      <a className='btn btn-info clickable' onClick={() => props.onShowPayment(pr.id)}>Pay</a>
    </td>
  }

  return <tr className='player'>
    <td className='col-xs-7 text-left player-name name'>
      <h5>
        <a className='clickable' onClick={() => props.onShowPlayer(pr.player_id)}>{pr.displayed_name}</a>
      </h5>
    </td>

    <td className='col-xs-3 text-center'>
      <div className='player-actions'>
        { !pr.player_fake &&
          <a onClick={() => props.onCopyPhone({id: pr.id})} title='Copy phone'>
            <img className='copy-phone-icon' src='/images/copy_phone.svg'/>
          </a>
        }
        { !pr.player_fake &&
          <a href={`/admins/direct_messages?player_id=${pr.player_id}`} title='Send message' target='_blank'>
            <i className='fa fa-solid fa-commenting-o' />
          </a>
        }
        { pr.declined && <img className='declined-icon' title='Declined payment' src='/images/declined_payment.png'/> }
        { pr.player_credit > 0 && <img className='credit-icon' title='Credits' src='/images/credit_icon.svg'/> }
        { !pr.player_fake && !isGameFull && !authHold &&
          <a
            id='guest-number-add'
            title='Add guest'
            onClick={() => props.onChangeGuests({id: pr.id, guestsNumber: pr.guests_number + 1})}
          >
            <img className='add-guest-icon' src='/images/add-guests-icon.svg'/>
          </a>
        }
        { pr.player_captain &&
          <i 
            className={'fa fa-solid fa-trophy game-captain' + (pr.is_game_captain ? ' active' : '')}
            title='Tag as a captain'
            onClick={() => props.toggleCaptain(pr)}
          />
        }
      </div>
    </td>

    <td className='col-xs-1 player-team'>
      <select
        name='team'
        className='player-team form-control' 
        defaultValue={pr.team} 
        onChange={(e) => props.onChangeTeam(e.target.value)}
      >
        {
          _.times(game.teams_count + 1).map(i => {
            const value = i == 0 ? '-' : i
            return <option key={i} value={i}>{value}</option>
          })
        }
      </select>
    </td>

    <td className='col-xs-2'>
      { !editCost &&
        <h5>
          <span className='cost'>$&nbsp;{cost_of_player.toFixed(2)}</span>&nbsp;
          { !pr.player_fake && !authHold && 
            <span className='toggle-cost-edit fa fa-pencil' onClick={() => setEditCost(true)}></span>
          }
        </h5>
      }
      { editCost &&
        <form className='edit_player_reservation'>
          <div className='dollar-field inline'>
            <input step='0.01' className='form-control' type='number' 
              autoFocus ref={costInputRef} onBlur={() => setTimeout(() => { setEditCost(false) }, 300)} />
          </div>
          <input type='submit' name='commit' value='OK' className='btn btn-info' 
            onClick={(e) => {e.preventDefault(); changeCost()}} />
        </form>
      }
    </td>

    <td className='col-xs-1 balance'>
      <h5>$&nbsp;{parseFloat(pr.balance).toFixed(2)}</h5>
    </td>

    {paymentAction()}

    <td className='col-xs-1'>
      <a className='btn btn-danger' onClick={() => props.onRemove(pr.id)}><i className='fa fa-trash-o'></i></a>
    </td>
  </tr>
}
